import { DateTime } from "luxon";

export const DEFAULT_DELIVERY_HOURS = {
  1: { from: { hour: 8, minute: 0 }, to: { hour: 22, minute: 0 } },
  2: { from: { hour: 8, minute: 0 }, to: { hour: 22, minute: 0 } },
  3: { from: { hour: 8, minute: 0 }, to: { hour: 22, minute: 0 } },
  4: { from: { hour: 8, minute: 0 }, to: { hour: 22, minute: 0 } },
  5: { from: { hour: 8, minute: 0 }, to: { hour: 22, minute: 0 } },
  6: { from: { hour: 8, minute: 0 }, to: { hour: 22, minute: 0 } },
  7: { from: { hour: 8, minute: 0 }, to: { hour: 22, minute: 0 } },
  timezone: "Europe/Paris",
};

export const getDayDeliveryHours = (deliveryHours, dayOfWeek = null) => {
  if (!deliveryHours) {
    deliveryHours = DEFAULT_DELIVERY_HOURS;
  }

  const timezone = deliveryHours.timezone || "Europe/Paris";
  const currentDayOfWeek =
    dayOfWeek || DateTime.now().setZone(timezone).weekday;

  const isPerDayFormat =
    typeof deliveryHours[1] === "object" ||
    typeof deliveryHours[2] === "object" ||
    typeof deliveryHours[3] === "object" ||
    typeof deliveryHours[4] === "object" ||
    typeof deliveryHours[5] === "object" ||
    typeof deliveryHours[6] === "object" ||
    typeof deliveryHours[7] === "object";

  if (isPerDayFormat) {
    const dayConfig = deliveryHours[currentDayOfWeek];
    if (!dayConfig) {
      return {
        from: DEFAULT_DELIVERY_HOURS[currentDayOfWeek].from,
        to: DEFAULT_DELIVERY_HOURS[currentDayOfWeek].to,
        timezone,
      };
    }
    return {
      from: dayConfig.from,
      to: dayConfig.to,
      timezone,
    };
  }

  return {
    from: deliveryHours.from || { hour: 8, minute: 0 },
    to: deliveryHours.to || { hour: 22, minute: 0 },
    timezone,
  };
};
